<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div
      class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex"
    >
      <dark-Toggler class="d-none d-lg-block" />
      <b
        :class="tempo_logout_tempo_ < 60 ? 'text-danger' : ''"
        id="tempo_logout_"
        >{{ tempo_logout_ }}</b
      >
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <b-nav-item-dropdown
        right
        toggle-class="d-flex align-items-center dropdown-user-link"
        class="dropdown-user"
      >
        <template #button-content>
          <div class="d-sm-flex d-none user-nav">
            <p class="user-name font-weight-bolder mb-0">{{ user.name }}</p>
            <span class="user-status">{{ user.company_name }}</span>
          </div>
          <b-avatar
            size="40"
            variant="light-primary"
            badge
            :src="srcImageUser"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>

        <b-dropdown-item link-class="d-flex align-items-center">
          <feather-icon size="16" icon="UserIcon" class="mr-50" />
          <router-link :to="'/profile'">
            <span> {{ $t("My profile") }}</span>
            <!-- Meu Perfil -->
          </router-link>
        </b-dropdown-item>
        <b-dropdown-item
          link-class="d-flex align-items-center"
          @click="openCompanyModal"
        >
          <feather-icon size="16" icon="BoldIcon" class="mr-50" />

          <span> {{ $t("Switch company") }}</span>
        </b-dropdown-item>
        <!-- <b-dropdown-item link-class="d-flex align-items-center pr-50"> -->
        <!-- </b-dropdown-item> -->

        <!-- <b-dropdown-item link-class="d-flex align-items-center">
            <feather-icon size="16" icon="MailIcon" class="mr-50" />
            <span>Inbox</span>
          </b-dropdown-item>
          
          <b-dropdown-item link-class="d-flex align-items-center">
            <feather-icon size="16" icon="CheckSquareIcon" class="mr-50" />
            <span>Task</span>
          </b-dropdown-item>
          
          <b-dropdown-item link-class="d-flex align-items-center">
            <feather-icon size="16" icon="MessageSquareIcon" class="mr-50" />
            <span>Chat</span>
          </b-dropdown-item> -->

        <b-dropdown-divider />

        <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
          <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
          <span>{{ $t("logOut") }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
    <!-- <locale-a /> -->

    <b-modal
      v-model="showModalCompany"
      centered
      title="Selecione a Empresa"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div>
        <ul class="list-unstyled mt-1">
          <li
            v-for="item in companiesList"
            :key="item.id"
            class="p-3 mb-3 border rounded shadow-sm d-flex justify-content-between align-items-center company-item"
          >
            <div>
              <span class="font-weight-bold text-primary">
                {{ item.name }}
              </span>
              <br />
              <small class="text-muted"> CNPJ: {{ item.cnpj }} </small>
            </div>
            <b-button
              variant="success"
              size="sm"
              class="ml-3 choose-btn"
              @click="chooseCompany(item.company_id)"
            >
              <i class="fas fa-check mr-1"></i> Escolher
            </b-button>
          </li>
        </ul>
      </div>

      <template #modal-footer>
        <b-button variant="secondary" @click="closeModalCompany">
          Continuar na empresa atual
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BLink,
  BNavbarNav,
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import DarkToggler from "@core/layouts/components/app-navbar/components/DarkToggler.vue";
import localeA from "@core/layouts/components/app-navbar/components/LocaleA";

export default {
  data() {
    return {
      authenticated: false,
      disabled: true,
      tempo_logout_tempo_: 301,
      tempo_logout_: "",
      user: {},
      companiesList: [],
      showModalCompany: false,
    };
  },
  components: {
    BLink,
    BNavbarNav,
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
    localeA,

    // Navbar Components
    DarkToggler,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    srcImageUser() {
      return this.user?.photo ?? "";
    },
  },
  methods: {
    closeModalCompany() {
      this.showModalCompany = false; // Fecha o modal
    },

    openCompanyModal() {
      this.showModalCompany = true; // Abre o modal
      this.getVerify();
    },
    getVerify() {
      const api = this.$store.state.api + "users/companies/" + this.user.id;
      axios
        .get(api)
        .then((response) => {
          this.companiesList = response.data;
          this.showModalCompany = true;
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },
    chooseCompany(companyId) {
      const api = this.$store.state.api + "change_company";
      axios
        .post(api, { company_id: companyId })
        .then(() => {
          this.$message("Sucesso", "Empresa alterada com sucesso!", "success");
          this.closeModalCompany();
          setTimeout(() => {
            window.location.reload(); // força reload completo
          }, 800);
        })
        .catch((error) => {
          this.$message(null, error.response.data, "error");
        });
    },
    logout: function () {
      let self = this;
      let api = this.$store.state.api + "logout";

      axios
        .post(api)
        .then((response) => {
          localStorage.removeItem("token");

          self.$router.push({ path: "/login" });
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.$message("Erro", "Erro ao realizar logout", "error");
        });
    },
    inactivityClock: function () {
      const self = this;

      let intervalo = setInterval(function () {
        self.tempo_logout_tempo_--;
        self.tempo_logout_ =
          "0" +
          Math.trunc(self.tempo_logout_tempo_ / 60) +
          ":" +
          (self.tempo_logout_tempo_ % 60).toString().padStart(2, "0");

        if (self.tempo_logout_tempo_ < 10) {
          $("#tempo_logout_").hide();
          setTimeout(function () {
            $("#tempo_logout_").show();
          }, 300);
        }
        if (self.tempo_logout_tempo_ === 0) {
          clearInterval(intervalo);
          self.logout();
        }
      }, 1000);
    },
  },
  mounted() {
    const self = this;

    // self.inactivityClock();

    // $(document).click(function(){
    //   self.tempo_logout_tempo_ = 301;
    // });
    // $(document).keypress(function(){
    //   self.tempo_logout_tempo_ = 301;
    // });

    setTimeout(function () {
      self.user = self.$store.state.user;
      if (self.user.password_expired == 1) {
        $("#modalChangePassword").modal({
          backdrop: "static",
          keyboard: false, // to prevent closing with Esc button (if you want this too)
        });
      }
    }, 100);
  },
};
</script>
